import React from 'react';
import { aboutContent } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -left-4 top-0 bottom-0 w-4 bg-[#0077B6] rounded-l-lg" />
            <img
              src={aboutContent.image}
              alt="Business IT Consulting"
              className="w-full rounded-lg shadow-xl"
            />
          </div>

          {/* Content */}
          <div>
            <span className="text-[#0077B6] font-semibold tracking-wider text-sm uppercase">About Us Company</span>
            <h2 className="text-[#0a2342] text-3xl md:text-4xl font-bold mt-2 mb-6">
              {aboutContent.title}
            </h2>
            {aboutContent.paragraphs.map((para, index) => (
              <p key={index} className="text-gray-600 mb-4 leading-relaxed">
                {para.split('**').map((part, i) => 
                  i % 2 === 1 ? <strong key={i} className="text-[#0a2342]">{part}</strong> : part
                )}
              </p>
            ))}
            <a
              href="#contact"
              className="inline-block mt-4 px-8 py-3.5 bg-[#0077B6] text-white font-semibold rounded-full hover:bg-[#005f8f] transition-colors uppercase tracking-wide text-sm"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
